export const monthsToYearsMonths = (months) => {
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  const parts = [];
  if (years > 0) parts.push(`${years} yr${years > 1 ? 's' : ''}`);
  if (remainingMonths > 0) parts.push(`${remainingMonths} mo${remainingMonths > 1 ? 's' : ''}`);
  return parts.length ? parts.join(' ') : '0 months';
};

export const calculateBasePayment = (principal, annualRate, termMonths) => {
  if (principal <= 0 || termMonths <= 0) return { monthlyPayment: 0, totalInterest: 0 };
  const monthlyRate = annualRate / 100 / 12;
  if (monthlyRate === 0) {
    const payment = principal / termMonths;
    return { monthlyPayment: payment, totalInterest: 0 };
  }
  const payment =
    (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -termMonths));
  const totalPaid = payment * termMonths;
  return { monthlyPayment: payment, totalInterest: totalPaid - principal };
};

export const calculateWithOverpayment = (
  principal,
  annualRate,
  baseMonthlyPayment,
  overpayment,
  termMonths
) => {
  const monthlyRate = annualRate / 100 / 12;
  let balance = principal;
  let month = 0;
  let totalInterest = 0;
  let totalPaid = 0;

  if (balance <= 0 || termMonths <= 0) {
    return { months: 0, totalInterest: 0, totalPaid: 0 };
  }

  while (balance > 0 && month < termMonths * 2) {
    const interest = monthlyRate === 0 ? 0 : balance * monthlyRate;
    const payment = Math.min(balance + interest, baseMonthlyPayment + overpayment);
    const principalPaid = payment - interest;

    if (principalPaid <= 0) {
      break;
    }

    balance = Math.max(balance - principalPaid, 0);
    totalInterest += interest;
    totalPaid += payment;
    month += 1;
  }

  return { months: month, totalInterest, totalPaid };
};
